const NpsResolutionStatus = {
  OPEN: 1,
  PROCESSED: 2,
  IGNORE: 3
}

export default NpsResolutionStatus
